import {
    APPLICATION_ACCESS_ALL_CHAIN_APPS,
    APPLICATION_ACCESS_REGION_APPS,
} from './consts/securityOptions'

export const hasRegionalOrAdminAccess = (userAccess?: string) =>
    userAccess === APPLICATION_ACCESS_REGION_APPS ||
    userAccess === APPLICATION_ACCESS_ALL_CHAIN_APPS
